import script from "./CitiesSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CitiesSearch.vue?vue&type=script&setup=true&lang=js"

import "./CitiesSearch.vue?vue&type=style&index=0&id=55eeb1f1&lang=scss"

const __exports__ = script;

export default __exports__